import { render, staticRenderFns } from "./report-own-income.vue?vue&type=template&id=8ba4f55c&scoped=true&"
import script from "./report-own-income.vue?vue&type=script&lang=ts&"
export * from "./report-own-income.vue?vue&type=script&lang=ts&"
import style0 from "./report-own-income.vue?vue&type=style&index=0&id=8ba4f55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4f55c",
  null
  
)

export default component.exports